import React, { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Mail, ArrowRight, CheckCircle2 } from "lucide-react";
import { useI18n, useLocalizedPath } from "../i18n/I18nContext";
import { api, formatApiError } from "../lib/api";
import { Field } from "./Register";

export default function ForgotPassword() {
  const { t, lang } = useI18n();
  const lp = useLocalizedPath();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email: email.trim(), language: lang });
      setSent(true);
    } catch (e2) {
      setError(formatApiError(e2.response?.data?.detail) || e2.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container py-16 md:py-24 max-w-md">
      <motion.div
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.55, ease: [0.16, 1, 0.3, 1] }}
        className="glass rounded-3xl p-8 md:p-10"
      >
        {sent ? (
          <>
            <CheckCircle2 className="h-9 w-9 text-gold" strokeWidth={1.75} />
            <h1 className="mt-6 font-display text-h1 tracking-tight">
              {lang === "en" ? "Check your inbox." : "Verifică-ți inbox-ul."}
            </h1>
            <p className="mt-3 text-cream-muted">{t.auth.checkInbox}</p>
            <Link to={lp("/login")} className="btn btn-ghost mt-8 inline-flex">
              {t.auth.submitLogin}
            </Link>
          </>
        ) : (
          <>
            <h1 className="font-display text-card-lg md:text-section tracking-tight leading-[1.05]">{t.auth.forgotTitle}</h1>
            <p className="mt-3 text-cream-muted">{t.auth.forgotSub}</p>
            <form onSubmit={onSubmit} className="mt-10 space-y-5">
              <Field icon={<Mail className="h-4 w-4 text-cream-dim" />} label={t.auth.email}>
                <input
                  required
                  type="email"
                  autoComplete="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder={t.auth.email}
                  className="input-bare"
                />
              </Field>
              {error && <p className="text-caption text-red-300/90">{error}</p>}
              <button type="submit" disabled={loading} className="btn btn-gold btn-lg w-full">
                {loading ? t.common.sending : t.auth.submitForgot}
                <ArrowRight className="h-4 w-4" />
              </button>
            </form>
          </>
        )}
      </motion.div>
    </div>
  );
}
